export function setCookie(name: string, value: string, days: number) {
  var expires = "";
  const domain = document.location.origin.includes(".spartacodingclub.kr")
    ? ".spartacodingclub.kr"
    : document.location.hostname;
  const sameSite = document.location.origin.includes(".spartacodingclub.kr")
    ? "; SameSite=None; Secure"
    : "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; domain=${domain}; expires=${date.toUTCString()}${sameSite}`;
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export const getCookie = (name: any) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return decodeURIComponent(parts.pop().split(";").shift());
};

export function serialize(obj: {
  [x: string]: string | number | boolean | Function;
  hasOwnProperty: (arg0: string) => any;
}) {
  var str: Array<string> = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      if (p) {
        const value = obj[p];
        if (typeof value === "string") {
          str.push(`${encodeURIComponent(p)}=${encodeURIComponent(value)}`);
        }
      }
    }
  return str.join("&");
}

export const parseCookie = (str: string) =>
  str
    .split("&")
    .map((v) => v.split("="))
    .reduce((acc: { [key: string]: any }, v) => {
      acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
      return acc;
    }, {});

export function handleResponse(response: {
  text: () => Promise<any>;
  ok: any;
  statusText: any;
}) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

export function getParam(name: string, url: string) {
  if (!url) url = location.href;
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(url);
  return results == null ? null : results[1];
}

export function deleteCookie(name: string) {
  if (getCookie(name)) {
    setCookie(name, "", -1);
  }
}
